export const lightTheme = {
    lightestBackground: '250,250,250', // lighest grey
    lightBackground: '246, 246, 246', // light grey
    mediumBackground: '237, 237, 237', // medium grey
    darkBackground: '145, 145, 145', // dark grey
    text: '4,4,4', // dark blue
    icon: '145, 145, 145',
    constants: {
        darkText: '4,4,4', //dark blue
        lightText: '238,238,238', //light grey
        colorBackground: '29,185,84', // whatsapp green
        purple: '91, 87, 115', // light whatsapp green
        yellow: '252,192,0',
        danger: '255,14,87', // bright red
        success: '0,162,184', // bright green
    },
};

export const darkTheme = {
    lightestBackground: '79,79,103', // lightest blue
    lightBackground: '65,65,84', // light blue
    mediumBackground: '36,36,47',
    darkBackground: '4,4,4', //dark blue
    text: '240,240,240', // light grey
    icon: '145, 145, 145',
    constants: {
        darkText: '4,4,4',
        lightText: '238,238,238',
        colorBackground: '29,185,84',
        purple: '91, 87, 115',
        yellow: '252,192,0',
        danger: '255,14,87',
        success: '0,162,184',
    },
};
